export const round = (value: number, decimals: number) => {
  return Number(value.toFixed(decimals));
};
